/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function BinCardInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (index, field, val) => {
    const newDetails = [...details];
    newDetails[index][field] = val;
    setFieldValue("details", newDetails);
  };

  // Auto Calculations for Balance and Totals
  useEffect(() => {
    let runningBalance = 0;
    let totalIn = 0;
    let totalOut = 0;

    const updatedDetails = details.map((row, idx) => {
      const inQty = parseFloat(row.inQuantity) || 0;
      const outQty = parseFloat(row.outQuantity) || 0;
      runningBalance = runningBalance + inQty - outQty;
      
      totalIn += inQty;
      totalOut += outQty;

      return {
        ...row,
        balance: runningBalance
      };
    });

    // Chỉ cập nhật nếu có sự thay đổi thực sự để tránh loop
    if (JSON.stringify(updatedDetails) !== JSON.stringify(details)) {
      setFieldValue("details", updatedDetails);
    }
    
    setFieldValue("totalInQuantity", totalIn);
    setFieldValue("totalOutQuantity", totalOut);
    setFieldValue("closingBalance", runningBalance);
  }, [JSON.stringify(details.map(d => ({ in: d.inQuantity, out: d.outQuantity })))]);

  const addRow = () => {
    const template = {
      ordinalNumber: String(details.length + 1).padStart(2, "0"),
      docDate: "",
      inDocNumber: "",
      outDocNumber: "",
      description: "",
      transactionDate: "",
      inQuantity: 0,
      outQuantity: 0,
      balance: 0,
      accountantConfirm: "",
    };
    setFieldValue("details", [...details, template]);
  };

  const removeRow = (index) => {
    if (details.length <= 1) return;
    const newDetails = details.filter((_, i) => i !== index).map((row, idx) => ({
      ...row,
      ordinalNumber: String(idx + 1).padStart(2, "0"),
    }));
    setFieldValue("details", newDetails);
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.5" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "15px", marginBottom: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 8px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 8px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "8px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "45%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "55%" }}>
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>Mẫu số S12-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "20px" }}>THẺ KHO (SỔ KHO)</h2>
        <div style={{ marginTop: 10 }}>
          Ngày lập thẻ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.creationDate} onChange={(e) => handleChangeField("creationDate", e.target.value)} />
        </div>
        <div style={{ marginTop: 5 }}>
          Tờ số: <input disabled={containView} style={{ ...s.inputDottedSmall }} value={values.sheetNumber} onChange={(e) => handleChangeField("sheetNumber", e.target.value)} />
        </div>
      </div>

      {/* MATERIAL INFO */}
      <div style={{ marginTop: "20px" }}>
        <div style={s.rowLabel}>- Tên, nhãn hiệu, quy cách vật tư: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.materialName} onChange={(e) => handleChangeField("materialName", e.target.value)} /></div>
        <div style={s.rowLabel}>- Đơn vị tính: <input disabled={containView} style={{ ...s.inputDotted, width: "200px" }} value={values.materialUnit} onChange={(e) => handleChangeField("materialUnit", e.target.value)} /></div>
        <div style={s.rowLabel}>- Mã số: <input disabled={containView} style={{ ...s.inputDotted, width: "200px" }} value={values.materialCode} onChange={(e) => handleChangeField("materialCode", e.target.value)} /></div>
      </div>

      {/* TABLE 10 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "50px" }} rowSpan={2}>Số TT</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Ngày, tháng</th>
              <th style={s.th} colSpan={2}>Số hiệu chứng từ</th>
              <th style={s.th} rowSpan={2}>Diễn giải</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Ngày nhập, xuất</th>
              <th style={s.th} colSpan={3}>Số lượng</th>
              <th style={{ ...s.th, width: "120px" }} rowSpan={2}>Ký xác nhận của kế toán</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "80px" }}>Nhập</th>
              <th style={{ ...s.th, width: "80px" }}>Xuất</th>
              <th style={{ ...s.th, width: "80px" }}>Nhập</th>
              <th style={{ ...s.th, width: "80px" }}>Xuất</th>
              <th style={{ ...s.th, width: "80px" }}>Tồn</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>E</th>
              <th style={s.th}>F</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>G</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {(details || []).map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.ordinalNumber} onChange={(e) => handleChangeTable(idx, "ordinalNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.docDate} onChange={(e) => handleChangeTable(idx, "docDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.inDocNumber} onChange={(e) => handleChangeTable(idx, "inDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.outDocNumber} onChange={(e) => handleChangeTable(idx, "outDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.description} onChange={(e) => handleChangeTable(idx, "description", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.transactionDate} onChange={(e) => handleChangeTable(idx, "transactionDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.inQuantity} onChange={(e) => handleChangeTable(idx, "inQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.outQuantity} onChange={(e) => handleChangeTable(idx, "outQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled style={s.inputTableRight} value={fmt(item.balance)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.accountantConfirm} onChange={(e) => handleChangeTable(idx, "accountantConfirm", e.target.value)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}
            {/* DÒNG CỘNG */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={{ ...s.td, textAlign: "center" }} colSpan={6}>Cộng cuối kỳ</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.totalInQuantity)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.totalOutQuantity)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.closingBalance)}</td>
              <td style={{ ...s.td, textAlign: "center" }}>X</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm nghiệp vụ</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: INFO */}
      <div style={{ marginTop: "15px" }}>
        <div style={s.rowLabel}>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => handleChangeField("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div style={s.rowLabel}>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.openingDate} onChange={(e) => handleChangeField("openingDate", e.target.value)} /></div>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
